import { Comments, CommentsPaginator } from '../shared/comments/models';

export const CommentsForUser = Comments.extend({
    initialize: function () {
        this.paginator = new CommentsPaginator({ limit: 10 });
        CommentsForUser.__super__.initialize.apply(this, arguments);
    },

    getTargetTypes: function () {
        var announcement = $f.shared.comments.utils.INCLUDE_TARGET_TYPES.ANNOUNCEMENT;
        var task = $f.shared.comments.utils.INCLUDE_TARGET_TYPES.TASK;
        var submission = $f.shared.comments.utils.INCLUDE_TARGET_TYPES.SUBMISSION;

        return [task, submission, announcement];
    },

    url: function () {
        var base_url = `/api/v2/comments/for_user/${$f.active_user.id}`;
        var url_params = new URLSearchParams();

        url_params.append('include_target_types', this.getTargetTypes());

        if (this.paginator) {
            url_params.append('start', this.paginator.get('start'));
            url_params.append('limit', this.paginator.get('limit'));
        }

        return `${base_url}/?${url_params}`;
    },

    /**
     * Notifications should show newest-to-last, unlike normal Comments collections
     */
    comparator: function (item) {
        return 0 - new Date(item.get('date_created')).getTime();
    }
});
